'use client';

import { useQuery } from '@tanstack/react-query';

import api from '@/lib/api';
import { publicSpeakerUserSignupsQueryKey } from './helpers';

/**
 * The signed-in citizen's own sign-ups on a meeting. Shared by the sign-up dialog and the
 * meeting-page card so both read the same cache entry and a withdrawal in one updates the other.
 */
export const useUserSignups = (governmentCode: string, meetingId: number, enabled = true) =>
  useQuery({
    enabled,
    queryKey: publicSpeakerUserSignupsQueryKey(governmentCode, meetingId),
    queryFn: () => api.governments.publicSpeakers(governmentCode).getUserSignups(meetingId),
    refetchOnMount: 'always',
  });
